import { render } from "./background.vue?vue&type=template&id=726c7b8c"
import script from "./background.vue?vue&type=script&lang=js"
export * from "./background.vue?vue&type=script&lang=js"

import "./background.vue?vue&type=style&index=0&id=726c7b8c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__